import HitTypes from 'models/search/hit_types';

export default function ensureFilterTypeSet(context, query) {
  if (query.filter.type || query.filter.types) {
    return query;
  }
  if (context.stores.appFeatures.get().isEnabled('tasksSearch')) {
    query.setFilterProperties({ types: [HitTypes.CONVERSATION, HitTypes.TASK] });
  } else {
    query.setType(HitTypes.CONVERSATION);
  }
  return query;
}
